/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
// React
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Lodash
import _ from 'lodash';

// I18n
import { Translate } from 'react-redux-i18n';

// React Spectrum Components
import {
  Flex,
  View,
  Button,
  Divider,
  DialogTrigger,
  ActionButton,
  Heading,
  Content,
  Text,
  ButtonGroup,
} from '@adobe/react-spectrum';

// Icons
import FilterIcon from '@spectrum-icons/workflow/Properties';

// React Router
import Dialog from '@react/react-spectrum/Dialog';
import Back from '@spectrum-icons/workflow/BackAndroid';
import Close from '@spectrum-icons/workflow/Close';
import { withRouter } from '../withRouter';

// Actions
import { clearAllFilters } from '../../actions/filterActions';

// Styles
import '../../styles/FilterContainer.scss';
import LocationFilter from './LocationFilter';
import MultiSelectFilter from './MultiSelectFilter';
import ToggleFilter from './ToggleFilter';
import SpecializedToggleFilter from './SpecializedToggleFilter';
import Accordion from '../global/Accordion/Accordion';
import PartnerAwardsToggleFilter from './PartnerAwardsToggleFilter';
import ProgramTypeConfig from '../../util/programTypeConfig';
import { INITIAL_STATE } from '../../reducers/filterReducer';
import SelectedFilterTag from './SelectedFilterTag';
import { filterTagNamesMap } from '../../util/util';

const MobileFilterContainer = ({
  appliedFilters,
  clearAllFiltersAction,
  router,
  programPath,
}) => {
  const applicableFilters = ProgramTypeConfig[programPath].apllicableFilters;
  const [filterOpen, setFilterOpen] = useState(false);
  // Check if certain filters are already applied
  const hiddenFiltersAlreadyApplied = (
    _.has(appliedFilters, 'industry')
    || _.has(appliedFilters, 'level')
    || _.has(appliedFilters, 'specialized')
  );

  const clearDisabled = _.isEqual({
    locationType: 'all',
  }, appliedFilters);

  // const filterCount = Object.keys(appliedFilters).filter((key) => {
  //   const value = appliedFilters[key];
  //   if (key === 'locationType' && value === 'all') {
  //     return false;
  //   }
  //   if (key === 'locationType' && appliedFilters.address) {
  //     return false;
  //   }
  //   return (
  //     (key !== 'sort') && (
  //       (Array.isArray(value) && value.length > 0)
  //       || value === true
  //       || (typeof value === 'string' && value.trim() !== '')
  //     )
  //   );
  // }).length;

  const filterCount = Object.keys(appliedFilters).reduce((count, key) => {
    const value = appliedFilters[key];
    if (key === 'address') {
      if (value !== undefined && value !== '') {
        count += 1;
      }
    } else if (key === 'locationType') {
      if (!appliedFilters.address && value !== 'all') {
        count += 1;
      }
    } else if (Array.isArray(value)) {
      count += value.length;
    } else if (value === true) {
      count += 1;
    } else if (key !== 'sort' && typeof value === 'string' && value.trim() !== '') {
      count += 1;
    }

    return count;
  }, 0);

  return (
    <View UNSAFE_className="filterContainer">
      <Button
        UNSAFE_style={{
          border: filterCount > 0 ? '1px solid #BCBCBC' : '1px solid #D3D3D3',
          borderRadius: '4px 0px 0px 4px',
          background: filterCount > 0 ? '#F4F4F4' : 'white',
          padding: '0px 10px',
          gap: '10px',
          height: '45px',
        }}
        onPress={() => setFilterOpen(true)}
      >
        <FilterIcon size="S" id="filterIcon" />
        Filter
        {filterCount > 0 && (
        <>
          <div style={{
            border: '1px solid #BCBCBC',
            height: '40px',
          }}
          />
          {filterCount}
        </>
        )}
      </Button>
      {filterCount > 0 && (
      <Button
        UNSAFE_style={{
          border: '1px solid #BCBCBC',
          borderRadius: '0px 4px 4px 0px',
          background: '#F4F4F4',
          height: '45px',
        }}
        onPress={() => clearAllFiltersAction(router, programPath)}
      >
        <Close size="S" height={30} />
      </Button>
      )}
      {filterOpen
      && (
      <Dialog
        isDismissible
        mode="fullscreenTakeover"
        open
        role="dialog"
        trapFocus
        className="full-screen-filter-overlay"
      >
        <Heading UNSAFE_style={{ margin: '70px 0px 0px 0px' }}>
          <Button isQuiet onPress={() => setFilterOpen(false)} UNSAFE_style={{ border: 'none' }}>
            <Back size="S" />
            <Text UNSAFE_style={{ color: '#505050', fontWeight: 'normal' }}>Filter by</Text>
          </Button>
        </Heading>
        <Divider size="S" />
        {filterCount > 0 && (
        <>
          <SelectedFilterTag />
          <Divider size="S" />
        </>
        )}

        <Content>
          {applicableFilters.location && (
          <>
            <Accordion
              title="Locations"
              borderStyle="none"
            >
              <LocationFilter />
            </Accordion>
            <Divider size="S" />
          </>
          )}
          {applicableFilters.applications && (
          <>
            <Accordion
              title="Applications"
              borderStyle="none"
              metadata={appliedFilters.solution?.length && <div className="setFilterIndicator">{appliedFilters.solution.length}</div>}
            >
              <MultiSelectFilter
                filterName="solution"
                nameTranslationPath="partner_finder.filters.products_label"
                infoTranslationPath="partner_finder.filters.products_info"
              />
            </Accordion>
            <Divider size="S" />
          </>
          )}
          {applicableFilters.partnerSolutions && (
          <>
            <Accordion
              title="Partner Solutions"
              borderStyle="none"
              metadata={appliedFilters['accredited-solutions'] && <div className="setFilterIndicator">{1}</div>}
            >
              <ToggleFilter />
            </Accordion>
            <Divider size="S" />
          </>
          )}
          {applicableFilters.initiatives && (
          <>
            <Accordion
              title="Initiatives"
              borderStyle="none"
              metadata={appliedFilters.initiatives?.length && <div className="setFilterIndicator">{appliedFilters.initiatives.length}</div>}
            >
              <MultiSelectFilter
                filterName="initiatives"
                nameTranslationPath="partner_finder.filters.industries_label"
                infoTranslationPath="partner_finder.filters.industries_info"
              />
            </Accordion>
            <Divider size="S" />
          </>
          )}
          {applicableFilters.industries && (
          <>
            <Accordion
              title="Industries"
              borderStyle="none"
              metadata={appliedFilters.industry?.length && <div className="setFilterIndicator">{appliedFilters.industry.length}</div>}
            >
              <MultiSelectFilter
                filterName="industry"
                nameTranslationPath="partner_finder.filters.industries_label"
                infoTranslationPath="partner_finder.filters.industries_info"
              />
            </Accordion>
            <Divider size="S" />
          </>
          )}
          {applicableFilters.partnerLevels && (
          <>
            <Accordion
              title="Partner levels"
              borderStyle="none"
              metadata={appliedFilters.level?.length && <div className="setFilterIndicator">{appliedFilters.level.length}</div>}
            >
              <MultiSelectFilter
                filterName="level"
                nameTranslationPath="partner_finder.filters.partner_level_label"
                infoTranslationPath="partner_finder.filters.partner_level_info"
              />
            </Accordion>
            <Divider size="S" />
          </>
          )}
          {applicableFilters.specialized && (
          <>
            <Accordion
              title="Specialized"
              borderStyle="none"
              isOpen
              metadata={appliedFilters.specialized && <div className="setFilterIndicator">{1}</div>}
            >
              <SpecializedToggleFilter />
            </Accordion>
            <Divider size="S" />
          </>
          )}
          {applicableFilters.partnerAwards && (
          <>
            <Accordion
              title="Partner Awards"
              borderStyle="none"
              metadata={appliedFilters.badges && <div className="setFilterIndicator">{1}</div>}
            >
              <PartnerAwardsToggleFilter />
            </Accordion>
            <Divider size="S" />
          </>
          )}

          <Flex justifyContent="end" margin="16px">
            <Button variant="secondary" isQuiet isDisabled={filterCount < 1} onPress={() => clearAllFiltersAction(router, programPath)} id="clear-all-filters-button" data-test-id="clear-all-filters-button">
              <Translate value="partner_finder.filters.clear_all" />
            </Button>
          </Flex>
        </Content>
      </Dialog>
      )}
    </View>
  );
};

MobileFilterContainer.propTypes = {
  appliedFilters: PropTypes.shape({
    location: PropTypes.shape({
      geo: PropTypes.string,
      country: PropTypes.string,
    }),
  }),
  clearAllFiltersAction: PropTypes.func.isRequired,
  router: PropTypes.shape({}).isRequired,
};

MobileFilterContainer.defaultProps = {
  appliedFilters: {},
};

const mapStateToProps = (state) => ({
  appliedFilters: state.filter.selected,
  totalResults: state.results.totalResults,
  programPath: state.facets.programPath,
});

const mapDispatchToProps = {
  clearAllFiltersAction: clearAllFilters,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MobileFilterContainer));
